import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { fetchAccountContact, fetchAddresses, fetchOrderAttributes, fetchOrderDeliveryLimits, useDispatch, useSelector, } from "@jti/store";
import { Loading } from "@jti/ui";
import { ShippingForm } from "../../../../forms/ShippingForm";
import { useAgeVerification } from "../../../../hooks/useAgeVerification";
import { useDeliveryLimit } from "../../../../hooks/useDeliveryLimit";
import { useTrialBlockingCheckout } from "../../../../hooks/useTrialBlockingCheckout";
import { AgeVerificationMessageBox } from "../../components/AgeVerificationMessageBox";
import { DeliveryLimitMessageBox } from "../../components/DeliveryLimitMessageBox";
import { TrialBlockingCheckoutMessageBox } from "../TrialBlockingCheckoutMessageBox";
import styles from "./ShippingPageContent.module.scss";
export const ShippingPageContent = ({ asideSubmitButtonWrapperRef }) => {
    const dispatch = useDispatch();
    const { isDeliveryLimitError } = useDeliveryLimit();
    const { isAgeVerificationError } = useAgeVerification();
    const { isTrialBlockingCheckout } = useTrialBlockingCheckout();
    const addressesFetchStatus = useSelector((state) => state.checkout.addresses.fetchStatus);
    const profileDataFetchStatus = useSelector((state) => state.checkout.profileDataFetchStatus);
    const orderDeliveryLimitsFetchStatus = useSelector((state) => state.checkout.orderDeliveryLimits.fetchStatus);
    const orderAttributesFetchStatus = useSelector((state) => state.checkout.orderAttributes.fetchStatus);
    const isLoading = [
        addressesFetchStatus,
        profileDataFetchStatus,
        orderDeliveryLimitsFetchStatus,
        orderAttributesFetchStatus,
    ].includes("pending");
    useEffect(() => {
        if (addressesFetchStatus === "idle") {
            dispatch(fetchAddresses());
        }
    }, [dispatch, fetchAddresses, addressesFetchStatus]);
    useEffect(() => {
        if (orderDeliveryLimitsFetchStatus === "idle") {
            dispatch(fetchOrderDeliveryLimits());
        }
    }, [dispatch, fetchOrderDeliveryLimits, orderDeliveryLimitsFetchStatus]);
    useEffect(() => {
        if (profileDataFetchStatus === "idle") {
            dispatch(fetchAccountContact());
        }
    }, [dispatch, profileDataFetchStatus, fetchAccountContact]);
    useEffect(() => {
        if (orderAttributesFetchStatus === "idle") {
            dispatch(fetchOrderAttributes(false));
        }
    }, [dispatch, fetchOrderAttributes, orderAttributesFetchStatus]);
    return (_jsxs("div", { className: styles.container, children: [_jsx(DeliveryLimitMessageBox, { isVisible: isDeliveryLimitError }), _jsx(AgeVerificationMessageBox, { isVisible: isAgeVerificationError }), _jsx(TrialBlockingCheckoutMessageBox, { isVisible: isTrialBlockingCheckout }), isLoading ? _jsx(Loading, {}) : _jsx(ShippingForm, { asideSubmitButtonWrapperRef: asideSubmitButtonWrapperRef })] }));
};
//# sourceMappingURL=ShippingPageContent.js.map